































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import headerTip from './header-tip/index.vue';
import { commaNumber } from '../format';

@Component({
  components: { headerTip }
})
export default class ParkingCount extends Vue {
  commaNumber: Function = commaNumber;
  // 页面数据
  @Prop()
  data: any;

  get free() {
    if (this.data && this.data.freePlateNum) {
      return this.data.freePlateNum;
    } else {
      return 0;
    }
  }

  get total() {
    if (this.data && this.data.plateNum) {
      return this.data.plateNum;
    } else {
      return 0;
    }
  }

  get percent() {
    if (this.data && this.data.freePlateRate) {
      return this.data.freePlateRate * 100;
    } else {
      return 0;
    }
  }

  mounted() {}
}
